import Vue from 'vue'
import App from './jobfair.vue'
import "@/common/config/init"

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
